import React from "react";

function CCTVRoles() {
    return (
        <div>
            <h2>Roles & Responsibilities of a CCTV Operator</h2>
            <p>
                CCTV operators are responsible for monitoring surveillance systems, identifying incidents, and supporting public safety. This module outlines the core duties, ethical expectations, and professional conduct required in this role.
            </p>

            <h3>Primary Duties</h3>
            <ul>
                <li>Monitor live CCTV feeds for suspicious or criminal activity</li>
                <li>Operate recording and playback systems</li>
                <li>Report incidents to supervisors or emergency services</li>
                <li>Maintain accurate logs and incident reports</li>
                <li>Ensure equipment is functioning correctly</li>
            </ul>

            <h3>Operational Responsibilities</h3>
            <ul>
                <li>Follow site-specific procedures and protocols</li>
                <li>Use surveillance equipment lawfully and responsibly</li>
                <li>Respond to alarms and coordinate with on-site security</li>
                <li>Preserve and label footage for evidence when required</li>
                <li>Control access to the CCTV control room</li>
            </ul>

            <h3>Ethical & Legal Conduct</h3>
            <ul>
                <li>Respect privacy and data protection laws</li>
                <li>Do not misuse or share footage without authorization</li>
                <li>Operate without bias or discrimination</li>
                <li>Maintain confidentiality at all times</li>
                <li>Avoid unnecessary or intrusive surveillance</li>
            </ul>

            <h3>Professional Standards</h3>
            <ul>
                <li>Stay alert and focused during shifts</li>
                <li>Communicate clearly and professionally</li>
                <li>Work well under pressure and in emergencies</li>
                <li>Keep up to date with training and legal updates</li>
                <li>Represent your employer and the industry with integrity</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – CCTV Training</a></li>
                <li><a href="https://ico.org.uk/for-organisations/guide-to-data-protection/" target="_blank" rel="noreferrer">ICO – Data Protection Guidance</a></li>
            </ul>
        </div>
    );
}

export default CCTVRoles;
